import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, null, -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  class: "d-flex justify-content-end gap-4",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "indicator-label" }
const _hoisted_8 = { class: "svg-icon svg-icon-2" }
const _hoisted_9 = { class: "indicator-progress" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)
const _hoisted_11 = {
  type: "button",
  class: "btn btn-light-primary max-sm-flex-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_upload_pdf"
}
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = { class: "card-body pt-0 vip-table" }
const _hoisted_14 = { class: "mw-100px overflow-hidden" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mw-100px overflow-hidden" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 0,
  class: "text-nowrap",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "indicator-label" }
const _hoisted_23 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" })
], -1)
const _hoisted_25 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-200px py-4",
  "data-kt-menu": "true"
}
const _hoisted_26 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "menu-item px-3" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "btn btn-icon btn-sm my-3 invisible" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_MBDatatableWithDisabled = _resolveComponent("MBDatatableWithDisabled")!
  const _component_ShipmentLabelPreview = _resolveComponent("ShipmentLabelPreview")!
  const _component_UploadShipmentLabel = _resolveComponent("UploadShipmentLabel")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            ref: "downloadButton",
            type: "button",
            class: "btn btn-light-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadZip())),
            disabled: _ctx.downloadButtonLoading
          }, [
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("shipmentLabel.batchDownload")), 1)
            ]),
            _createElementVNode("span", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
            ])
          ], 8, _hoisted_6)), [
            [_directive_auth, { auth: ['export'] }],
            [_vShow, _ctx.checkedFileIds.length > 0]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr045.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("shipmentLabel.uploadShipmentLabel")), 1)
          ])), [
            [_directive_auth, { auth: ['add'] }]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_MBDatatableWithDisabled, {
        class: "mb-data-table-with-disabled",
        loading: _ctx.loading,
        "table-data": _ctx.tableData,
        "table-header": _ctx.tableHeader,
        "enable-items-per-page-dropdown": true,
        "current-page": _ctx.currentPage,
        total: _ctx.total,
        "rows-per-page": _ctx.pageSize,
        selection: true,
        "selection-disabled-condition": _ctx.selectionDisabledCondition,
        onSelectChange: _ctx.onRowsSelectChange,
        onCurrentChange: _ctx.onCurrentPageChange,
        onItemsPerPageChange: _ctx.onRowsPerPageChange
      }, {
        "cell-tracking_no": _withCtx(({ row: logisticsDocItem }) => [
          _createTextVNode(_toDisplayString(logisticsDocItem.tracking_no), 1)
        ]),
        "cell-channel": _withCtx(({ row: logisticsDocItem }) => [
          _createTextVNode(_toDisplayString(logisticsDocItem.channel), 1)
        ]),
        "cell-service_provider": _withCtx(({ row: logisticsDocItem }) => [
          _createTextVNode(_toDisplayString(logisticsDocItem.__show.service_provider), 1)
        ]),
        "cell-created_at": _withCtx(({ row: logisticsDocItem }) => [
          _createVNode(_component_el_popover, {
            placement: "top",
            width: "auto",
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(logisticsDocItem.created_at)), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatDateTime(logisticsDocItem.created_at, "YYYY-MM-DD HH:mm")) + " ", 1)
            ]),
            _: 2
          }, 1024)
        ]),
        "cell-stock_time": _withCtx(({ row: logisticsDocItem }) => [
          (logisticsDocItem.stock_time != '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                _createVNode(_component_el_popover, {
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(logisticsDocItem.stock_time)), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(logisticsDocItem.stock_time, "YYYY-MM-DD HH:mm")) + " ", 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, "--"))
        ]),
        "cell-status": _withCtx(({ row: logisticsDocItem }) => [
          _createElementVNode("span", {
            class: _normalizeClass(["badge", {
              'badge-light-dark': logisticsDocItem.status == 0,
              'badge-light-primary': logisticsDocItem.status == 10,
              'badge-light-info': logisticsDocItem.status == 20,
              'badge-light-warning': logisticsDocItem.status == 30,
              'badge-light-success': logisticsDocItem.status == 40,
              'badge-light-danger': logisticsDocItem.status == 90,
            }])
          }, _toDisplayString(_ctx.options.logisticsDocumentsItemsStatus.find((item) => {
                return item.value == logisticsDocItem.status;
              })?.label), 3)
        ]),
        "cell-action": _withCtx(({ row: logisticsDocItem }) => [
          (logisticsDocItem.status != 90)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (logisticsDocItem.file_path != '')
                  ? _withDirectives((_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-icon btn-bg-light btn-color-dark btn-sm me-3",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modal_logistics_doc_image_preview",
                      onClick: ($event: any) => (_ctx.imagePreviewDataChange(logisticsDocItem))
                    }, [
                      _createElementVNode("span", _hoisted_20, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen004.svg" })
                      ])
                    ], 8, _hoisted_19)), [
                      [_directive_auth, { auth: ['update', 'export'] }]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "btn btn-icon btn-bg-light btn-color-dark btn-sm my-3",
                  id: `action-button-${logisticsDocItem.id}`,
                  "data-kt-menu-trigger": "click",
                  "data-kt-menu-placement": "bottom-end"
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen052.svg" })
                    ])
                  ]),
                  _hoisted_24
                ], 8, _hoisted_21)), [
                  [_directive_auth, { auth: ['update', 'export'] }]
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                    default: _withCtx(() => [
                      (
                    logisticsDocItem.status == 0 ||
                    logisticsDocItem.status == 10
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", {
                              class: "menu-link px-3",
                              onClick: ($event: any) => (_ctx.repealItem(logisticsDocItem.id))
                            }, _toDisplayString(_ctx.t("shipmentLabel.void")), 9, _hoisted_27)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          onClick: ($event: any) => (
                      _ctx.downloadPdf(logisticsDocItem.id, logisticsDocItem.file_id)
                    )
                        }, _toDisplayString(_ctx.t("shipmentLabel.downloadPDF")), 9, _hoisted_29)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
        ]),
        _: 1
      }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "selection-disabled-condition", "onSelectChange", "onCurrentChange", "onItemsPerPageChange"])
    ]),
    _createVNode(_component_ShipmentLabelPreview, {
      searchParams: _ctx.imagePreviewParams,
      onUpdateList: _ctx.updateList
    }, null, 8, ["searchParams", "onUpdateList"]),
    _createVNode(_component_UploadShipmentLabel, { onUpdateList: _ctx.updateList }, null, 8, ["onUpdateList"])
  ]))
}